(function () {
  /* Checklist: once someone ticks a sign, offer the next step */
  document.querySelectorAll('[data-ws-check]').forEach(function (box) {
    var cta = box.querySelector('[data-ws-check-cta]');
    if (!cta) return;
    var rows = box.querySelectorAll('.ws-check__row');
    box.addEventListener('click', function (e) {
      if (!e.target.closest('.ws-check__row')) return;
      setTimeout(function () {
        var c = box.querySelectorAll('.ws-check__row[aria-pressed="true"]').length;
        if (c > 0 && cta.hidden) { cta.hidden = false; requestAnimationFrame(function () { cta.classList.add('is-in'); }); }
        if (c === 0) { cta.classList.remove('is-in'); cta.hidden = true; }
      }, 0);
    });
  });
})();
